export default {
  state: {
    viewTags: [],
  },
  mutations: {
    pushViewTags(state, route) {
      let target = state.viewTags.find((item) => item.path === route.path)
      let isName = route.name
      if (!target && isName) {
        state.viewTags.push({ ...route, scrollTop: 0 })
      }
    },
    removeViewTags(state, route) {
      state.viewTags.forEach((item, index) => {
        if (item.path === route.path) {
          state.viewTags.splice(index, 1)
        }
      })
    },
    updateViewTags(state, route) {
      state.viewTags.forEach((item) => {
        if (item.path == route.path) {
          item = Object.assign(item, route)
        }
      })
    },
    updateViewTagsTooltip(state, route) {
      let newTags = state.viewTags.map((item) => {
        if (item.path === route.nowFullPath) {
          item = Object.assign({}, item, { tooltip: route.tooltip })
        }
        return { ...item }
      })
      state.viewTags = newTags
    },
    updateViewTitle(state, route) {
      let newTags = state.viewTags.map((item) => {
        if (item.path === route.nowFullPath) {
          item = Object.assign({}, item)
          item.meta.title = route.title
        }
        return { ...item }
      })
      state.viewTags = newTags
    },
    clearViewTags(state) {
      state.viewTags = []
    },
  },
}
